import {
  STOCK_DICTIONARY_EDIT_TRANSLATION_PENDING,
  STOCK_DICTIONARY_EDIT_TRANSLATION_DISMISS_ERROR,
} from '../constants';

export function editDictionaryTranslation(id, translation) {
  return (dispatch) => {
    dispatch({
      type: STOCK_DICTIONARY_EDIT_TRANSLATION_PENDING,
      data: { id, translation }
    })
  }
}

export function dismissEditDictionaryTranslationError() {
  return {
    type: STOCK_DICTIONARY_EDIT_TRANSLATION_DISMISS_ERROR
  }
}